import { BsFillCheckCircleFill } from "react-icons/bs";
import { AiFillCloseCircle } from "react-icons/ai";
import ReactTooltip from "react-tooltip";
export default function DailyScheduleTable({
  dailySchedule,
  daysLength,
}: {
  dailySchedule: {
    type: string;
    val: string;
    ispublic: string;
    pre_price: string;
    Account_side_name: string;
    daynum: string;
  }[];
  daysLength: number;
}) {
  console.log("dailySchedule", dailySchedule);
  function getTableItems(type: number, index: number): JSX.Element | void {
    let daySchedule = dailySchedule.filter((value) => {
      return parseInt(value.daynum) == index;
    });
    // filter day
    switch (type) {
      case 7:
        for (let item = 0; item < daySchedule.length; item++) {
          if (+daySchedule[item].type === 7 && +daySchedule[item].val === 1) {
            return <td>هتل</td>;
          }
          if (+daySchedule[item].type === 7 && +daySchedule[item].val === 2) {
            return <td>هتل آپارتمان</td>;
          }
          if (+daySchedule[item].type === 7 && +daySchedule[item].val === 3) {
            return <td>اقامتگاه بومگردی</td>;
          }
          if (+daySchedule[item].type === 7 && +daySchedule[item].val === 4) {
            return <td>خانه محلی</td>;
          }
          if (+daySchedule[item].type === 7 && +daySchedule[item].val === 5) {
            return <td>کمپ</td>;
          }
        }
        return <td>-</td>;

      default:
        var place, by;
        for (let item = 0; item < daySchedule.length; item++) {
          if (+daySchedule[item].type == type) {
            if (daySchedule[item].pre_price == "0")
              by = (
                <td>
                  <AiFillCloseCircle style={{ color: "#ff6666" }}></AiFillCloseCircle>
                </td>
              );

            if (daySchedule[item].pre_price != "0")
              by = (
                <td>
                  <BsFillCheckCircleFill style={{ color: "green", width: "100px !important" }}></BsFillCheckCircleFill>
                </td>
              );

            if (!daySchedule[item].Account_side_name) {
              place = <td>-</td>;
            } else if (+daySchedule[item].ispublic) {
              place = <td>{daySchedule[item].Account_side_name}</td>;
            } else if (!+daySchedule[item].ispublic) {
              place = <td>-</td>;
            }

            // if (!+daySchedule[item].ispublic) {
            //   return (
            //     <>
            //       <td>-</td>

            //       <td>-</td>
            //     </>
            //   );
            // }
            // if (daySchedule[item].pre_price == "0") {
            //   return (
            //     <>
            //       <td>-</td>
            //       <td>
            //         <AiFillCloseCircle style={{ color: "#ff6666" }}></AiFillCloseCircle>
            //       </td>
            //     </>
            //   );
            // } else {
            //   return (
            //     <>
            //       <td>{!!daySchedule[item].Account_side_name ? daySchedule[item].Account_side_name : "-"}</td>
            //       <td>
            //         <BsFillCheckCircleFill style={{ color: "green", width: "100px !important" }}></BsFillCheckCircleFill>
            //       </td>
            //     </>
            //   );
            // }
          }
        }

        return (
          <>
            {place ? place : <td>-</td>}
            {by ? by : <td>-</td>}
          </>
        );
    }
  }
  return (
    <>
      {/* Table */}
      <ReactTooltip />
      <div className="d-flex mt-5 align-content-center">
        <p className="mx-auto" style={{ fontWeight: 900, fontSize: 30 }}>
          <span className=" material-icons mt-2" style={{ color: "rgb(11, 80, 11)", fontSize: 40 }}>
            restaurant
          </span>
          پذیرایی و محل اقامت
        </p>
      </div>
      <div className="d-flex mx-5" style={{ overflowX: "auto" }}>
        <div className="did"></div>
        <table className="table  Tablestyle col-lg-10 col-md-6 col-sm-12 " style={{ height: 400, fontSize: 20, fontWeight: 600 }}>
          <tbody>
            <tr className="TableDetails">
              <th rowSpan={2} className="Day">
                روز
              </th>
              <th colSpan={2}>صبحانه</th>
              <th colSpan={2}>نهار</th>
              <th colSpan={2}>شام</th>
              <th colSpan={2} style={{ borderTopLeftRadius: 15 }}>
                اقامتگاه
              </th>
            </tr>
            <tr className="TableDetails" style={{ fontWeight: 600, fontSize: 20 }}>
              <td>مکان</td>
              <td>توسط</td>
              <td>مکان</td>
              <td>توسط</td>
              <td>مکان</td>
              <td>توسط</td>
              <td style={{ borderBottomLeftRadius: 15 }}>محل</td>
            </tr>
            {[...Array(daysLength)].map((dayNumber, index) => {
              return (
                <tr className="FirstRow">
                  <td className="Day">
                    روز
                    {index == 0 ? " حرکت " : index}
                  </td>
                  {/* صبحانه */}
                  {getTableItems(0, index)}

                  {/* ناهار */}
                  {getTableItems(2, index)}
                  {/* شام */}
                  {getTableItems(5, index)}
                  {/* اقامتگاه */}
                  {getTableItems(7, index)}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
